
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import whatsappFn from '~/mixins/whatsappFn.js';
import lgmMixin from '~/mixins/lgmMixin';

export default {
  name: "QdapHomeQuestionnaireProductCard",
  mixins: [eventTrackingMixins, whatsappFn, lgmMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    stateId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    getPromotionData() {
      return {
        Theme: 'Promotion_Tag',
        Icon: {
          url: require('~/assets/images/family/icon/price-tag.svg'),
        },
        Title: this.$i18n.t('qdap.questionnaire.productCard.promotion'),
        Content: [ { Text: this.data?.discount } ]
      }
    },
  },
  methods: {
    async handleCTAClick(targetUrl) {
      const eventTrackingParams = this.handleTracking();

      await this.$goToURL(targetUrl, false, eventTrackingParams, {
        getLGMConversionId: this.getLGMConversionId,
        injectLGMConversionId: this.injectLGMConversionId
      });
      
    },
    handleTracking() {
      const eventTrackingParams = this.initEventTrackingParams();

      eventTrackingParams.a = 'open_whatsapp';
      eventTrackingParams.l = this.data?.scenarioCode;
      eventTrackingParams.c = 'qdap_questionnaire_product_card_cta';
      eventTrackingParams.xr_id = this.stateId;
      eventTrackingParams.insurer_name = this.data?.insuranceCompany.logoAlt;
      eventTrackingParams.product_name = this.data?.name;
      eventTrackingParams.product_category = 'deferred-annuity';

      this.sendEventTracking(eventTrackingParams);
      
      return eventTrackingParams
    },
  }
}
